import { connect } from 'react-redux';
import BulletinBoard from './bulletin-board';
import { loadCardsForBulletinBoardAction, getPinnedContentAction, onLoadCourse } from '../../reducers/course.reducers';

const mapStateToProps = state => ({
  config: state.authentication.config,
  bulletinBoard: state.courses.bulletinBoard,
  cards: state.courses.bulletinBoardCards,
});

const mapDispatchToProps = dispatch => ({
  loadCards: (boardId, sortFilterDto) => dispatch(loadCardsForBulletinBoardAction({ boardId, sortFilterDto })),
  loadCourse: course => dispatch(onLoadCourse(course)),
  getPinnedContentAction: (boardId, sortFilterDto) => dispatch(getPinnedContentAction({ boardId, sortFilterDto })),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulletinBoard);



// WEBPACK FOOTER //
// ./src/app/main/bulletin-board/bulletin-board.container.js